// extracted by mini-css-extract-plugin
module.exports = {"ContactMain":"Contact_ContactMain__2HkzY","ContactSec":"Contact_ContactSec__1gYhf","profilePic":"Contact_profilePic__1Sy8x","Idtab":"Contact_Idtab__2PcLn"};